import data from "./projects.json";

export const categories = data.categories;
// Work filter chips exclude the Playground pseudo-category.
export const workCategories = data.categories.filter((c) => c.id !== "playground");
export const industries = data.industries;

export const projects = [...data.projects].sort((a, b) => (a.order || 0) - (b.order || 0));
export const workProjects = projects.filter((p) => (p.section || "work") === "work");
export const playgroundProjects = projects.filter((p) => p.section === "playground");

export const projectCount = workProjects.length;
export const playgroundCount = playgroundProjects.length;

export function asset(path) {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("/")) return path;
  return "/" + path;
}

export const featured = workProjects.filter((p) => p.featured).sort((a, b) => (a.order || 0) - (b.order || 0));

export function getProject(slug) {
  return projects.find((p) => p.slug === slug);
}
export function getNext(slug) {
  const i = projects.findIndex((p) => p.slug === slug);
  return i === -1 ? projects[0] : projects[(i + 1) % projects.length];
}
export function getPrev(slug) {
  const i = projects.findIndex((p) => p.slug === slug);
  return i === -1 ? projects[0] : projects[(i - 1 + projects.length) % projects.length];
}
export function categoryLabel(id) {
  const c = categories.find((c) => c.id === id);
  return c ? c.label : id;
}

const TAGMAP = { brand: ".AI", campaign: ".PSD", packaging: ".AI", social: ".JPG", decks: ".PDF", motion: ".MP4", product: ".FIG", playground: ".EPS" };
export function fileTagsFor(project) {
  const tags = [TAGMAP[project.category] || ".EPS"];
  if (project.cover?.mp4) tags.push(".MP4");
  return tags;
}

// Return sets in authored order (In motion already comes first in the data).
export function sectionItems(section) {
  return section.sets || [];
}

export const slugRedirects = {
  "abu-dhabi-mobility": "gcc-traffic-week",
  "chaos": "chaos-command-center",
  "unicef": "unicef-esaro",
  "awc": "awc-flame",
  "dhwani": "alphabet-cards",
  "chini-flashcards": "flashcards",
};
